import React from 'react';
import {Text, TouchableOpacity} from 'react-native';
import Entypo from 'react-native-vector-icons/Entypo';
import {Colors} from '../../../../constants/Colors';

interface IDropDownFilter {
  title: string;
  onPress: () => void;
  activeComponent: boolean;
}

const DropDownProfile = ({
  title,
  onPress,
  activeComponent,
}: IDropDownFilter) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        alignSelf: 'center',
        borderBottomWidth: 1,
        borderColor: Colors.GrayPallete.lightgrayTwo,
        paddingHorizontal: 20,
        height: 70,
      }}>
      <Text
        style={{
          fontSize: 16,
          fontFamily: 'TCCC-UnityHeadline Regular',
          lineHeight: 18,
          color: Colors.GrayPallete.lightgrayThree,
        }}>
        {title}
      </Text>
      {activeComponent ? (
        <Entypo name="chevron-thin-up" size={16} color={'red'} />
      ) : (
        <Entypo name="chevron-thin-right" size={16} color={'black'} />
      )}
    </TouchableOpacity>
  );
};

export default DropDownProfile;
